export default "__VITE_PUBLIC_ASSET__d2caef2b__"